import React, {
    useContext,
    useState,
    useEffect,
} from 'react';
import { useNavigate } from "react-router";
import { format } from "date-fns";
import { useQuery, useMutation } from '@tanstack/react-query';

import { getCustomer, NotificationContext, handleError } from '../router'

import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";
import LoadingIndicator from '../components/loading-indicator';

const CustomerMemberhips = () => {

    const {notification, setNotification} = useContext(NotificationContext);

    let navigate = useNavigate();

    const { data: customer, isPending, isFetching } = getCustomer();

    const [customerMemberships, setCustomerMemberships] = useState([]);

    const {
        isPending: membershipsPending,
        data: membershipsData,
    } = useQuery({
        queryKey: ['membershipsData'],
        queryFn: QUERIES.getMemberships,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });

    const addMembership = useMutation({
        mutationFn: (membershipId) => QUERIES.addMembership([{membership: membershipId, autoRenew: true}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            navigate(`/basket`);
        },
    });

    useEffect(() => {
        if (!customer?.subscriptions?.length || !membershipsData?.length) return;

        const memberships = UTILS.getCustomerMembershipData(customer, membershipsData);
        setCustomerMemberships(memberships);
    }, [membershipsData]);

    if (membershipsPending) return <LoadingIndicator />;
    if (!customerMemberships) return null;

    return (
        customerMemberships.map((membership) => {
            if (!membership.id) return;
            const expiry_date = format(membership.expiryDate, "EEE d MMM yyyy");
            return (
                <section key={membership.id} className='customer-membership'>
                    <h2 className='booking-pathway__header'>You are a {membership.name}</h2>
                    <p className='customer-membership__info'>Membership expires on {expiry_date}</p>
                    {membership.canRenew &&
                        <button type="button" className='btn' onClick={() => addMembership.mutateAsync(membership.id)}>
                            Renew
                            {addMembership.isPending &&
                                <LoadingIndicator />
                            }
                        </button>
                    }
                </section>
        )})
    );
};

export default CustomerMemberhips;